// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_ASSET } from "./action";

export function canDeleteAsset(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_ASSET);
}
